﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG, TOGGLE_UTBETALING } from './Types';

export const initialState: ValgState = {
    brukerInfo: undefined,
    utdanning: undefined,
    land: undefined,
    periode: undefined,
    visUtbetaling: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.brukerInfo) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_UTBETALING: {
                return {
                    ...state,
                    visUtbetaling: !state.visUtbetaling,
                };
            }
            default:
                return state;
        }
    }
}
